export { Home as default } from './home';
